const Light = ({ width, height, color, ...props }) => (
  <svg
    width={width || '18'}
    height={height || '20'}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 8V1L1 12H8L8 19L17 8L10 8Z"
      stroke={color || '#0061CE'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Light;
